import { Component, OnInit, Input } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { LlmSettingService } from 'src/app/_services/llm-setting.service';

@Component({
  selector: 'app-llm-models-modal',
  templateUrl: './llm-models-modal.component.html',
  styleUrls: ['./llm-models-modal.component.scss']
})
export class LlmModelsModalComponent implements OnInit {
  modelData: any = {};
  loading = false;
  modelProviderType: string;
  selectedModelId: string;

  constructor(
    private modalRef: NzModalRef,
    private llmSettingService: LlmSettingService,
    // private message: Toast
  ) { }

  @Input() set providerType(value: string) {
    this.modelProviderType = value;
  }

  ngOnInit(): void {
    if (this.modelProviderType) {
      this.loadModels();
    }
  }

  loadModels() {
    this.loading = true;
    const params: any = {};
    if (this.modelProviderType) {
      params.llmModelProviderType = this.modelProviderType;
    }

    this.llmSettingService.getLlmModels(params).subscribe(
      (res: any) => {
        this.modelData = res || {};
        this.loading = false;
        
        // Auto-select first model ID if available
        if (this.modelData.modelIds && this.modelData.modelIds.length > 0) {
          this.selectedModelId = this.modelData.modelIds[0];
        } else {
          this.selectedModelId = null;
        }
      },
      (error) => {
        console.error('Failed to load models:', error);
        this.loading = false;
      }
    );
  }

  applyToLlmSetting() {
    if (!this.selectedModelId) {
      // this.message.warning('Please select a model ID first');
      return;
    }

    const result = {
      providerName: this.modelData.providerName,
      apiEndpoint: this.modelData.apiEndpoint,
      modelId: this.selectedModelId,
      docUrl: this.modelData.docUrl
    };

    this.modalRef.close(result);
  }

  close() {
    this.modalRef.close();
  }
}